import styled from "styled-components";
import { COLORS } from "../../../constants";

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const LabelValueContainer = styled.div`
  display: flex;
  width: 350px;
  padding: 10px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  flex-shrink: 0;
`;

const RadioContainer = styled.div`
  display: flex;
  width: 350px;
  padding: 10px 20px;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
`;

const Label = styled.label`
  color: #C3645E;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const Value = styled.span`
  color: ${COLORS.PRIMARY};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const LanguageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 50px 0px 0px 20px;
  border-radius: 20px;
  background: ${COLORS.WHITE};
`;

const FlagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const FlagContainer = styled.div`
  padding: 5px;
  cursor: pointer;
  box-sizing: content-box;
  border: none;
  margin: 5px 0;
  &:hover {
    opacity: 0.8;
  }
`;

const MainContainer = styled.div`
  padding: 50px 20px 120px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-start;
`;

const FormContainer = styled.div`
  padding: 50px 20px 120px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;

`;

const EditIconContainer = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  padding: 10px;
  cursor: pointer;
`;

const ProfessionContainer = styled.div`
  display: inline-flex;
  padding: 10px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 20px 0px 0px 20px;
  background: #FFF;
  position: absolute;
  bottom: -18px;
  right: 0;
`;

const AvatarContainer = styled.div`
display: flex;
width: 50px;
height: 50px;
padding: 30px;
justify-content: center;
align-items: center;
border-radius: 50px;
background: #A75550;
box-shadow: 0px 4px 15.7px 0px rgba(0, 0, 0, 0.25);
`;

const Input = styled.input`
  color: #C3645E;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 100%;
  display: inline;
`;

export {
  ColumnContainer,
  LabelValueContainer,
  Label,
  Value,
  LanguageContainer,
  FlagsContainer,
  FlagContainer,
  MainContainer,
  EditIconContainer,
  ProfessionContainer,
  AvatarContainer,
  Input,
  FormContainer,
  RadioContainer,
}
